export default __webpack_public_path__ + "static/media/closing-icon.73749751.png";